import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import NextIcon from '@material-ui/icons/ArrowForwardIos';
import PrevIcon from '@material-ui/icons/ArrowBackIos';
import IconButton from '@material-ui/core/IconButton';
import CorrectIcon from '@material-ui/icons/Done';
import IncorrectIcon from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';
import { img, staticsUrl } from '../../../config';
import EyeIcon from '@material-ui/icons/RemoveRedEye';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    fontFamily: theme.typography.body1.fontFamily,
  },
  correct: {
    color: theme.palette.error.main,
  },
  incorrect: {
    color: theme.palette.success.main,
  },
  quiz: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    '& > div': {
      position: 'relative',
      overflow: 'auto',
      margin: '20px 0',
      textAlign: 'center',
      width: 500,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
    },
    '& p': {
      margin: '0 0 0.5em',
    },
  },
  quizDesc: {
    margin: '14px 0',
    lineHeight: 1.3,
  },
  qPagination: {
    color: '#666',
    fontWeight: 600,
  },
  quizAction: {
    textAlign: 'center',
    marginTop: 10,
    '& button': {
      margin: '0 1px',
    },
    '& > div': {
      display: 'inline-block',
      padding: '0.25em 1em',
      color: '#a1008f',
      verticalAlign: 'middle',
      margin: '0 1px',
      borderRadius: 3,
    },
  },
  glance: {
    display: 'inline-block',
    padding: '0 0.5em',
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: '#777',
    transition: 'color 0.3s',
    '&:hover': {
      color: 'green',
    },
  },
  isCorrect: {
    display: 'inline-block',
    width: 50,
    textAlign: 'center',
  },
  action: {
    textAlign: 'center',
    marginTop: 10,
  },
  preview: {
    display: 'inline-block',
    width: '100%',
    border: '1px solid #666',
    borderRadius: 3,
    padding: '3px 10px',
    fontSize: 16,
    textAlign: 'center',
    color: 'green',
    boxSizing: 'border-box',
  },
  input: {
    display: 'flex',
    width: 400,
    maxWidth: '100%',
    margin: '10px auto',
    justifyContent: 'center',
    alignItems: 'center',
    '& input': {
      width: '100%',
      border: '1px solid #666',
      borderRadius: 3,
      padding: '5px 10px',
      fontSize: 16,
      textAlign: 'center',
      boxSizing: 'border-box',
    },
  },
  introTitle: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  textSpeach: {
    background: '#eee',
    padding: '0 20px',
    borderRadius: 5,
  },
  quizIntro: {
    background: '#efefef',
    borderRadius: 5,
    padding: '20px 10px 5px',
    marginBottom: 20,
  },
  closeQuiz: {
    position: 'absolute',
    top: 0,
    right: 0,
    color: '#999',
    transition: 'color 0.3s',
    cursor: 'pointer',
    '&:hover': {
      color: '#333',
    },
  },
  imgNav: {
    '& > button': {
      margin: '0 10px',
    }
  },
  '@media(max-width: 850px)': {

  }
}));

let timeout1 = 0;
let timeout2 = 0;

function NewExercise(props) {
  const classes = useStyles();
  const [ no, setNo ] = useState(0);
  const [ imgNo, setImgNo ] = useState(0);
  const [ isCorrect, setIsCorrect ] = useState(null);
  const [ answer, setAnswer ] = useState('');
  const [ testFinished, setTestFinished ] = useState(false);
  const [ preview, setPreview ] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const len = exercise.sentences.length;
  const inputRef = useRef(null);
  const { images, texts } = exercise;

  useEffect(() => {
    init();
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    }
    // eslint-disable-next-line
  }, []);

  const init = () => {
    startStats(type);
  }

  const drawText = () => {
    const textNo = Math.floor(imgNo / 2);
    return <div className={classes.texts}>{texts[textNo]}</div>
  }

  const drawImgs = () => {
    const imgUrl = images[imgNo].imageUrl;
    const title = images[imgNo].title;
    const len = images.length

    const next = () => {
      action();
      if (imgNo < len - 1) {
        setImgNo(imgNo + 1);
      } else {
        setImgNo(0);
      }
    }

    const prev = () => {
      action();
      if (imgNo > 0) {
        setImgNo(imgNo - 1);
      } else {
        setImgNo(len - 1);
      }
    }

    return <div className={classes.images}>
      <p>{title}</p>
      <img src={staticsUrl + imgUrl} alt='' />
      {images.length > 1 && <div className={classes.imgNav}>
        <IconButton size="medium" onClick={prev}>
          <PrevIcon fontSize="inherit" />
        </IconButton>
        <IconButton  size="medium" onClick={next}>
          <NextIcon fontSize="inherit" />
        </IconButton>
      </div>}
    </div>
  }

  const drawQuiz = () => {
    const question = exercise.sentences[no];

    const next = () => {
      action();
      if (no < len - 1) {
        setNo(no + 1);
        setAnswer('');
        setIsCorrect(null);
      } else {
        finishTest();
      }
    }

    const cleanString = str => {
      if (str.indexOf('.') === str.length - 1) {
        str = str.substr(0, str.length - 1);
      }
      return str.trim().toLowerCase();
    }
    
    const checkAnswer = () => {
      action();
      const ok = cleanString(question.answer) === cleanString(answer);
      if ( ok) {
        correct();
      } else {
        incorrect();
      }
    }
    const correct = () => {
      props.media.success();
      setIsCorrect(true);
      timeout2 = setTimeout(() => {
        next();
      },2000)
    }
    const incorrect = () => {
      props.media.failure();
      setIsCorrect(false);
    }
    const showPreview = () => {
      action();
      setPreview(true);
      timeout1 = setTimeout(() => {
        setPreview(false);
      }, 2000);
    }
    const handleKeyDown = (ev) => {
      action();
      if (ev.key === 'Enter') checkAnswer();
    }
    const finishTest = () => {
      setTestFinished(true);
      props.media.finish();
      finishExercise();
    }
    const pagination = (no + 1) + '/' + len;
    return (
      <div className={classes.quiz}>
        <div>
         
          <div className={classes.quizIntro}>
            <div className={classes.introTitle} dangerouslySetInnerHTML={{__html: exercise.title}} />
            {images.length > 0 && drawImgs()}
            {texts.length > 0 && drawText()}
            <div className={classes.quizDesc} dangerouslySetInnerHTML={{__html: exercise.description}} />
          </div>
          
          <p>{question.text}</p>
          <div className={classes.input}>
            <div className={classes.glance} onClick={showPreview}><EyeIcon /></div>
            {!preview && <input 
              type="text"
              value={answer}
              onChange={ev => setAnswer(ev.target.value)}
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck={false}
              onKeyDown={handleKeyDown}
              ref={inputRef}
            />}
            {preview && <div className={classes.preview}>{question.answer}</div>}
            <div className={classes.isCorrect}>
              {isCorrect && <span style={{color: 'green'}} ><CorrectIcon /></span>}
              {isCorrect === null && <span style={{color: 'green'}}>?</span>}
              {isCorrect === false && <span style={{color: 'red'}}><IncorrectIcon /></span>}
            </div>
          </div>
          <div className={classes.qPagination}>{pagination}</div>
          <div className={classes.quizAction}>
            {!testFinished && <Button variant="outlined" color="secondary" onClick={checkAnswer} disabled={preview || !answer}>
              Sprawdź
            </Button>}
            {testFinished && <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classes.wrapper}>
      <div>
        {drawQuiz()}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(NewExercise);
